(function () {
  if (window.__fpNativeSupportBridge) return;
  window.__fpNativeSupportBridge = true;
  function syncHeaderOffset() {
    var header = document.getElementById('header');
    var height = header ? header.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--support-header-current-height', height + 'px');
  }
  function localizeSupportLinks() {
    var root = document.getElementById('fp-support-content');
    if (!root) return;
    var prefix = (root.dataset.marketRoot || '/').replace(/\/$/, '');
    if (!prefix) return;
    root.querySelectorAll('a[href^="/pages/"],a[href^="/products/"],a[href^="/search"],a[href^="/apps/"]').forEach(function(a) {a.setAttribute('href', prefix + a.getAttribute('href'));});
  }

  function init() {
    localizeSupportLinks();
    syncHeaderOffset();
    var toggle = document.querySelector('#header details.mobile-toggle-wrapper');
    if (toggle) {
      function reconcileClosedMenu() {
        if (!toggle.open && toggle.classList.contains('active') && !document.body.classList.contains('mobile-menu-open')) {
          toggle.classList.remove('active');
        }
      }
      reconcileClosedMenu();
      new MutationObserver(reconcileClosedMenu).observe(toggle, { attributes: true, attributeFilter: ['class', 'open'] });
      toggle.querySelector('summary').addEventListener('click', function() {
        toggle.classList.toggle('active', toggle.open);
      }, true);
    }
    var header = document.getElementById('header');
    if (header && window.ResizeObserver) new ResizeObserver(syncHeaderOffset).observe(header);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('resize', syncHeaderOffset, { passive: true });
  document.addEventListener('shopify:section:load', function() {
    localizeSupportLinks();
    syncHeaderOffset();
  });
})();
